import actions from './actionTypes';
import { fabric } from 'fabric';
import * as Constants from '../utilities/constants/Constants';
import { string } from '../localization';
import {
  addBackgroundToCanvas,
  addElementToCanvas,
  addTextToCanvas,
  isImageBasedBackground,
  getStartupScenePlacing,
  continueWithLoadCanvas,
  isFurnitureLayout,
  isWallLayout,
  minimumSceneWidth,
  minimumSceneHeight,
  getScaleToFillCanvasFactorForScene,
  scenePadding,
  loadProjectCanvas,
  canvasElementsExceptBackground,
  isBackground,
  backgroundElement,
  isValidEmailAddress,
  sendEmailToRecipients
} from './fabricCanvasActionHelpers';
import {
  objectIsSelected,
  handleTabChange,
  setLoaderCoordinates,
  getFirstTheme,
  getFolderListElements,
  clearDocumentColors,
  setDocumentColors,
  submitAddText,
  resetTextTemplate,
  handleUploadDialogueState
} from './sideBarActions';
import * as api from '../services/api';
import {
  isProjectDirty,
  isARCEnabled,
  shouldSelectFirstSceneOfFirstTheme,
  checkForPosterVersion,
  isBlockchainTransactionEnabled,
  getCategoryOfProduct,
  isSignageSuiteProduct,
  isLockedProject,
  isExpiredProject,
  isDeletedProject,
  isNonEditableInspiration,
  convertFromMetricToImperial,
  getActiveCanvas,
  isRoomMode,
  isStickerWorkspaceMode
} from '../utilities/HelperFunctions/HelperFunctions';
import { isLaptopsApp } from '../utilities/HelperFunctions/SignageHelperFunctions';
import {
  gaOfHittingRipLink,
  gaForCanvasAction,
  solidColorGA
} from '../utilities/GAHelpers/GAHelpers';
import { Placing, copyPlaceable } from './ProjectData/Placing';
import {
  initiateProjectSave,
  initiateProjectAndCall,
  saveOnlyIfDirtyAndCall,
  setWebUserInfo,
  saveProjectAndCall
} from './projectSaveAndLoader';
import { UserPhoto, SolidColor, tieleValue } from './ProjectData/Placebale';
import {
  Project,
  copyProject,
  activeScenePlacing,
  addScenePlacing
} from './ProjectData/Project';
import {
  canShowtemplateSelectionDialogueIn3D,
  showOrHideTemplateSelectionDialogue
} from './actions/wallHandler';
import {
  generatePreviewsOfSideWalls,
  getLeftProjectsWidth,
  getModelLeftProjectsWidth,
  getMultiProjectsWidth,
  getRightWithCurrentProjectsWidth,
  isSharedScene,
  resetActiveProject,
  setSharedSceneTo,
  unstretchSideProjects
} from './actions/multiWallHandler';
import {
  addMeasurementLines,
  removeMeasurementLines,
  refreshMeasurementLines
} from './actions/canvasMeasurementHandler';
import {
  checkIfCanvasApp,
  checkIfStickersTypeApp,
  updateCanvasForChangeInSize
} from './homeActions';
import {
  checkForPixelationWarning,
  checkObjectForPixelation,
  setShowPixelationWindowDialogue
} from './actions/pixelationHandler';
import {
  checkForMappedPlacings,
  createNewStickerAction,
  enebaleOrDisableStickerDrag,
  generatePreviewOfStickers,
  updateStickerIdList
} from './actions/stickerActions';
import {
  deleteAction,
  drawTiledImages,
  setFilteredTools
} from './actions/ToolbarActions';

export const initiateProject = () => async dispatch => {
  if (dispatch(checkIfStickersTypeApp())) {
    dispatch(createNewStickerAction());
  }
  dispatch(initiateProjectSave());
};

export const setFirstSceneOfFirstTheme = () => dispatch => {
  dispatch(handleTabChange(Constants.BACKGROUND_TAB_KEY));
  const data = dispatch(getFirstTheme());
  if (data) {
    dispatch(getFolderListElements(data));
    dispatch(
      addToCanvas(data.elements[0], null, () => {
        dispatch(setLoadingState(string.LOADING_KEY));
        dispatch(
          initiateProjectAndCall(() => {
            dispatch(setLoadingState(null));
          })
        );
      })
    );
  }
};

export const saveIsClicked = () => async dispatch => {
  dispatch(saveProjectAndCall());
};

export const checkForPosterVersionName = () => dispatch =>
  dispatch(checkForPosterVersion());

export const gaOfHittingRipLinkDetails = label => dispatch =>
  dispatch(gaOfHittingRipLink(label));

export const fetchingIsDone = () => dispatch => {
  dispatch({
    type: actions.SET_PROJECT_INITIATED,
    payload: { value: true }
  });
};

export const updatePlacingCoords = canvasElement => (dispatch, getState) => {
  if (Object.prototype.hasOwnProperty.call(canvasElement, 'placing')) {
    const oldAngle = canvasElement.angle;
    canvasElement.rotate(0);
    const flatCoordinates = {
      left: canvasElement.left,
      top: canvasElement.top
    };
    canvasElement.set({ flatCoordinates });
    canvasElement.rotate(oldAngle);

    const canvas = dispatch(getActiveCanvas(canvasElement.placing));
    let projectScale = getState().home.projectHeight / canvas.height;

    if (isImageBasedBackground(canvasElement)) {
      const canvasSize = dispatch(canvasSizeWithPadding());
      projectScale =
        (getState().home.projectHeight + dispatch(scenePadding())) /
        canvasSize.height;
    }
    const { placing } = canvasElement;

    if (placing.tiled) {
      const { tiledDimensions } = canvasElement;
      placing.width = tiledDimensions.width * tiledDimensions.scale;
      placing.height = tiledDimensions.height * tiledDimensions.scale;
    } else {
      placing.width = canvasElement.width * canvasElement.scaleX * projectScale;
      placing.height =
        canvasElement.height * canvasElement.scaleY * projectScale;
    }
    placing.yOffset = flatCoordinates.top * projectScale;
    placing.xOffset = flatCoordinates.left * projectScale;
    placing.angle = canvasElement.angle
      ? 360 - canvasElement.angle
      : canvasElement.angle;
  }
};

export const updateProjectPlacingsCoords = () => (dispatch, getState) => {
  const { wallCanvas, roomCanvas } = getState().fabricCanvas;
  const { project } = getState().finalCheck;
  project.width = getState().home.projectWidth;
  project.height = getState().home.projectHeight;
  let zIndex = 1;

  wallCanvas.forEachObject(object => {
    if (Object.prototype.hasOwnProperty.call(object, 'placing')) {
      dispatch(updatePlacingCoords(object));
      object.placing.zIndex = zIndex++;
    }
  });
  roomCanvas.forEachObject(object => {
    if (Object.prototype.hasOwnProperty.call(object, 'placing')) {
      dispatch(updatePlacingCoords(object));
      object.placing.zIndex = zIndex++;
    }
  });
};

export const requestSampleIsClicked = () => (dispatch, getState) => {
  dispatch(setWebLinkSaveIdentifier(Constants.DESIGN_KEY));
  dispatch(setSendPreviewWithLoupe(true));
  if (isProjectDirty(getState().fabricCanvas)) {
    const dict = {
      header: string.PRE_CHECK_SAVE_DIALOG_TITLE,
      description: string.PRE_CHECK_SAVE_DIALOG_MESSAGE,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: () => {
        dispatch(saveOnlyIfDirtyAndCall()).then(() => {
          dispatch(handleRequestSample());
        });
      },
      onCancel: null,
      buttonTitles: {
        finish: string.SAVE_KEY,
        cancel: string.CANCEL_TEXT_KEY
      }
    };
    dispatch(setMessageDialogParams(dict));
  } else {
    dispatch(
      saveOnlyIfDirtyAndCall().then(() => {
        dispatch(handleRequestSample());
      })
    );
  }
};

export const resetProject = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  project.id = null;
  project.activeWall = null;
  project.projectGroupId = null;
  project.token = null;
  project.scenePlacings = [];
  project.elementPlacings = [];
  project.visualizePlacings = [];
  project.removedVisualizePlacings = [];
  project.removedPlacings = [];
  if (dispatch(checkIfStickersTypeApp())) {
    dispatch({
      type: actions.SET_ACTIVE_STICKER_ID,
      payload: { id: null }
    });
    dispatch({
      type: actions.SET_STICKER_ID_LIST,
      payload: { list: [] }
    });
    dispatch({
      type: actions.SET_STICKER_PREVIEW_LIST,
      payload: { list: [] }
    });
  }
  dispatch({
    type: actions.SET_PROJECT_INITIATED,
    payload: { value: false }
  });
  dispatch(clearCanvas());
  dispatch(setWallCanvas(null));
  dispatch(setRoomCanvas(null));
};

//  Setting state for saving dialog
export const setLoadingState = state => (dispatch, getState) => {
  let count = getState().fabricCanvas.loadingCount;
  if (state === null) {
    count -= 1;
  } else {
    count += 1;
  }
  dispatch({
    type: actions.SET_SAVE_STATE,
    payload: {
      loadingState: state,
      loadingCount: count
    }
  });
};

export const projectHasInternalContents = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  let hasInternal = false;
  if (wallCanvas) {
    const backgroundEle = backgroundElement(wallCanvas);
    if (!backgroundEle) {
      return true;
    }
    if (backgroundEle.placing.externalPlaceable) {
      return true;
    }
    wallCanvas.forEachObject(element => {
      if (element.placing && element.placing.externalPlaceable) {
        hasInternal = true;
      }
    });
  }
  return hasInternal;
};

export const clearUndoInstance = () => (dispatch, getState) => {
  getState().fabricCanvas.undoInstance.clear();
};

export const loadInspiration = e => async (dispatch, getState) => {
  dispatch(clearDocumentColors());
  const oldProjectId = getState().finalCheck.project.id;
  const project = new Project();
  copyProject(project, e.dataJSON);
  dispatch({
    type: actions.SET_PROJECT_STRUCTURE,
    payload: { project }
  });

  project.deletableProjectId = oldProjectId;
  const { inspirationFilterIds } = project;
  const matchedCategories = getState().sideBar.inspirationCategory.filter(
    inspirationFilter => inspirationFilterIds.indexOf(inspirationFilter.id) > -1
  );
  matchedCategories.forEach(matchedCategory => {
    if (
      matchedCategory.category == Constants.covidInspirationCategory ||
      matchedCategory.category == Constants.windowsOfHopeInspirationCategory
    ) {
      const supportedViewingDistances = getState().modal.envData
        .supported_viewing_distances;
      const farDistanceIndex = supportedViewingDistances.length - 1;
      const farDistance = supportedViewingDistances[farDistanceIndex];
      project.targetViewingDistance = farDistance;
    }
  });

  dispatch(loadProjectCanvas(project, true, false)).then(() => {
    dispatch(makeProjectDirtyWithNoUndoSupport(true));
  });
  dispatch(setDocumentColors(e.dataJSON.inspiration_colors));
};

export const loadCanvas = () => async (dispatch, getState) => {
  const promiseObj = new Promise(resolve => {
    const { multiWallProjects, project } = getState().finalCheck;
    if (multiWallProjects.length > 1) {
      multiWallProjects.forEach(inProject => {
        if (inProject.id == project.id) {
          dispatch(loadProjectCanvas(inProject, false, false)).then(resolve);
        } else {
          dispatch(loadProjectCanvas(inProject, false, true)).then(resolve);
        }
      });
    } else {
      dispatch(loadProjectCanvas(project, false, false)).then(() => {
        if (dispatch(checkIfStickersTypeApp())) {
          dispatch(createNewStickerAction());
        }
        resolve();
      });
    }
  });
  let errorHeader = null;
  let errorMessage = null;
  if (dispatch(isLockedProject())) {
    errorHeader = string.LOCKED_PROJECT;
    errorMessage = string.LOCKED_MESSAGE;
  } else if (dispatch(isExpiredProject())) {
    errorHeader = string.EXPIRED_PROJECT;
    errorMessage = string.EXPIRED_MESSAGE;
  } else if (dispatch(isDeletedProject())) {
    errorHeader = string.DELETED_PROJECT;
    errorMessage = string.DELETED_MESSAGE;
  }
  if (errorHeader) {
    const dict = {
      header: errorHeader,
      description: errorMessage,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: () => {
        dispatch(enableViewMode());
      },
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatch(setMessageDialogParams(dict));
  }
  return promiseObj;
};

const enableViewMode = () => (dispatch, getState) => {
  getState().modal.envData.view_only_preview_mode = true;
  dispatch({
    type: actions.ENTER_VIEW_ONLY_PREVIEW_MODE,
    payload: {
      value: true
    }
  });
};

export const setRoomCanvas = roomCanvas => dispatch => {
  dispatch({
    type: actions.SET_ROOM_CANVAS,
    payload: {
      roomCanvas
    }
  });
};

export const setWallCanvas = wallCanvas => dispatch => {
  dispatch({
    type: actions.SET_WALL_CANVAS,
    payload: {
      wallCanvas
    }
  });
};

export const addSolidColors = element => dispatch => {
  dispatch(setSidebarVisibility(false));

  let fillColor = '000000';
  if (element.substr(0, 1) == '#') {
    fillColor = element.substr(1);
  }
  dispatch(solidColorGA(element));
  dispatch(addSolidColorToCanvas(fillColor.toUpperCase()));
};

export const addSolidColorToCanvas = colorElement => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const placeable = new SolidColor(colorElement);
  const placing = new Placing(placeable);
  if (dispatch(isSharedScene())) {
    dispatch(setSharedSceneTo(project, false));
    dispatch(unstretchSideProjects());
  }
  dispatch(continueAddSolidColorToCanvas(placing));
};

export const continueAddSolidColorToCanvas = placing => (
  dispatch,
  getState
) => {
  const { wallCanvas } = getState().fabricCanvas;
  const rect = new fabric.Rect({
    height: wallCanvas.height,
    width: wallCanvas.width,
    strokeWidth: 0,
    fill: `#${placing.placeable.color}`,
    placing,
    hasControls: false,
    layer: Constants.LAYER_ID_BACKGROUND
  });
  dispatch(addBackgroundElement(rect, wallCanvas));
};

export const canvasDidResize = (windowWidth, windowHeight) => (
  dispatch,
  getState
) => {
  if (windowWidth && windowHeight) {
    dispatch(updateWindowDimensions(windowWidth, windowHeight)).then(() => {
      const {
        dimensions,
        roomCanvas,
        wallCanvas,
        viewType
      } = getState().fabricCanvas;
      if (dispatch(checkIfCanvasApp())) {
        if (viewType == Constants.THREE_D_TYPE) {
          dispatch(
            updateCanvasSize(
              roomCanvas,
              dimensions.canvasWallScaleWidth,
              dimensions.canvasWallScaleHeight
            )
          );
        } else {
          dispatch(updateCanvasSize(roomCanvas, 10, 10));
        }
      }
      dispatch(
        updateCanvasSize(
          wallCanvas,
          dimensions.projectScaleWidth,
          dimensions.projectScaleHeight
        )
      );
    });
  }
};

export const loadCanvasFromProject = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  dispatch(continueWithLoadCanvas(project, false, false));
};

export const sampleModelSize = () => (dispatch, getState) => {
  let sampleWidth = getState().modal.storeData.sampleWindowWidth;
  let sampleHeight = getState().modal.storeData.sampleWindowHeight;
  const { projectWidth, projectHeight } = getState().home;

  if (projectWidth <= sampleWidth) {
    //  as per cappaccino caluculation
    sampleWidth = projectWidth / 2;
  }
  if (projectHeight <= sampleHeight) {
    //  as per cappaccino caluculation
    sampleHeight = projectHeight / 2;
  }
  return { width: sampleWidth, height: sampleHeight };
};

const updateNonTiledBackgroundForChangeInCanvasSize = (
  element,
  canvas,
  canvasOldWidth,
  canvasOldHeight
) => dispatch => {
  const originalViewScale = dispatch(
    getScaleToFillCanvasFactorForScene(element)
  );

  const elementOldCenterX = -element.left + canvasOldWidth / 2;
  const elementOldCenterY = -element.top + canvasOldHeight / 2;
  const ratioX = elementOldCenterX / element.getScaledWidth();
  const ratioY = elementOldCenterY / element.getScaledHeight();

  const { scaleSliderValue } = element;
  const sliderCalculatedValue =
    Constants.MINIMUM_ZOOM_VALUE +
    (scaleSliderValue *
      (Constants.MAXIMUM_ZOOM_VALUE - Constants.SLIDER_MIN_VALUE)) /
      Constants.SLIDER_MAX_VALUE;
  element.scale(originalViewScale * sliderCalculatedValue);
  element.setCoords();

  const elementNewCenterX = ratioX * element.getScaledWidth();
  const elementNewCenterY = ratioY * element.getScaledHeight();
  let newLeft = -(elementNewCenterX - canvas.width / 2);
  let newTop = -(elementNewCenterY - canvas.height / 2);

  const newEndX = newLeft + element.getScaledWidth();
  const newEndY = newTop + element.getScaledHeight();

  if (newEndX < canvas.width) {
    newLeft += canvas.width - newEndX;
  } else if (newLeft > 0) {
    newLeft = 0;
  }

  if (newEndY < canvas.height) {
    newTop += canvas.height - newEndY;
  } else if (newTop > 0) {
    newTop = 0;
  }

  element.top = newTop;
  element.left = newLeft;
  element.setCoords();
};

const updateTiledBackgroundForChangeInCanvasSize = (
  element,
  canvas,
  canvasOldWidth,
  canvasOldHeight
) => dispatch => {
  const scaleFactor = dispatch(
    getScaleToFillCanvasFactorForScene(element.unTileObject)
  );

  const elementOldCenterX = -element.left + canvasOldWidth / 2;
  const elementOldCenterY = -element.top + canvasOldHeight / 2;
  const ratioX = elementOldCenterX / element.getScaledWidth();
  const ratioY = elementOldCenterY / element.getScaledHeight();

  element.width = element.unTileObject.width * scaleFactor;
  element.height = element.unTileObject.height * scaleFactor;

  element.setCoords();

  const elementNewCenterX = ratioX * element.getScaledWidth();
  const elementNewCenterY = ratioY * element.getScaledHeight();
  let newLeft = -(elementNewCenterX - canvas.width / 2);
  let newTop = -(elementNewCenterY - canvas.height / 2);

  const newEndX = newLeft + element.getScaledWidth();
  const newEndY = newTop + element.getScaledHeight();

  if (newEndX < canvas.width) {
    newLeft += canvas.width - newEndX;
  } else if (newLeft > 0) {
    newLeft = 0;
  }

  if (newEndY < canvas.height) {
    newTop += canvas.height - newEndY;
  } else if (newTop > 0) {
    newTop = 0;
  }
  element.top = newTop;
  element.left = newLeft;
  element.setCoords();

  dispatch(
    drawTiledImages(
      element,
      element,
      element.tiledDimensions,
      element.tiledDimensions.scale,
      canvas,
      null
    )
  );
};

export const updateCanvasSize = (canvas, newWidth, newHeight) => (
  dispatch,
  getState
) => {
  if (!canvas) {
    return;
  }
  const canvasOldWidth = canvas.width;
  const canvasOldHeight = canvas.height;
  canvas.setHeight(newHeight);
  canvas.setWidth(newWidth);
  const canvasNewWidth = canvas.width;
  const canvasNewHeight = canvas.height;
  const resizedSaleX = canvasNewWidth / canvasOldWidth;
  const resizedSaleY = canvasNewHeight / canvasOldHeight;
  canvas.forEachObject(element => {
    if (isImageBasedBackground(element)) {
      if (!element.placing.tiled) {
        dispatch(
          updateNonTiledBackgroundForChangeInCanvasSize(
            element,
            canvas,
            canvasOldWidth,
            canvasOldHeight
          )
        );
      } else {
        dispatch(
          updateTiledBackgroundForChangeInCanvasSize(
            element,
            canvas,
            canvasOldWidth,
            canvasOldHeight
          )
        );
      }
    } else if (
      Object.prototype.hasOwnProperty.call(element, 'placing') &&
      element.placing.placeableType === Constants.SOLID_FILL_KEY
    ) {
      element.width = canvas.width;
      element.height = canvas.height;
    } else {
      //  Patch: As per the project requirement object resize should behave differently when window is resized and project is resized.
      //  Hence not scaling objects when project size is changed and scaling the objects when window is resized.
      if (!getState().home.wallSizeChangedFlag) {
        element.scaleX *= resizedSaleX;
        element.scaleY *= resizedSaleY;
      }
      element.top *= resizedSaleY;
      element.left *= resizedSaleX;
      if (isFurnitureLayout(element)) {
        dispatch(
          setPositionForElement(
            element,
            canvas,
            element.left,
            canvas.height - element.getScaledHeight()
          )
        );
      }
    }
    element.setCoords();
    removeMeasurementLines(element, canvas);
  });
  canvas.renderAll();
  dispatch(toggleDirtyBit());

  dispatch(redrawCanvas());
  //  Refresh canvas to redraw ruler when project size is changed
  if (getState().home.wallSizeChangedFlag) {
    dispatch({
      type: actions.WALL_SIZE_CHANED_FLAG,
      payload: {
        value: false
      }
    });
    if (dispatch(isSharedScene())) {
      dispatch(generatePreviewsOfSideWalls());
    }

    //  Patch: Render canvas to redraw ruler
    if (!getState().modal.storeData.hideRuler) dispatch(redrawCanvas());
  }
};

export const windowDidResize = (windowWidth, windowHeight) => (
  dispatch,
  getState
) =>
  new Promise(resolve => {
    dispatch(updateWindowDimensions(windowWidth, windowHeight)).then(() => {
      const {
        dimensions,
        viewType,
        roomCanvas,
        wallCanvas
      } = getState().fabricCanvas;
      if (dispatch(checkIfCanvasApp())) {
        if (viewType == Constants.THREE_D_TYPE) {
          dispatch(
            updateCanvasSize(
              roomCanvas,
              dimensions.canvasWallScaleWidth,
              dimensions.canvasWallScaleHeight
            )
          );
        } else {
          dispatch(updateCanvasSize(roomCanvas, 10, 10));
        }
      }
      dispatch(
        updateCanvasSize(
          wallCanvas,
          dimensions.projectScaleWidth,
          dimensions.projectScaleHeight
        )
      );
      resolve();
    });
  });

const getCanvasOffsetX = () => (dispatch, getState) => {
  const { dimensions } = getState().fabricCanvas;
  if (isSignageSuiteProduct()) {
    if (dimensions.orgWindowWidth && dimensions.orgWindowWidth < 767) {
      return Constants.SIGNAGE_MOBILE_CANVAS_OFFSET_X;
    }
    return Constants.SIGNAGE_CANVAS_OFFSET;
  }
  return Constants.WALLART_CANVAS_OFFSET;
};

const getCanvasOffsetY = () => (dispatch, getState) => {
  const { dimensions } = getState().fabricCanvas;
  const { multiWallProjects } = getState().finalCheck;

  if (isSignageSuiteProduct()) {
    if (dimensions.orgWindowWidth && dimensions.orgWindowWidth < 767) {
      return Constants.SIGNAGE_MOBILE_CANVAS_OFFSET_Y;
    }
    if (dispatch(isStickerWorkspaceMode())) {
      return Constants.SIGNAGE_CANVAS_OFFSET + 50;
    }
    return Constants.SIGNAGE_CANVAS_OFFSET;
  }
  if (multiWallProjects.length >= 2) {
    return Constants.WALLPAPER_CANVAS_OFFSET_Y;
  }
  return Constants.WALLART_CANVAS_OFFSET;
};

export const calculateModelViewSizeWRTWindow = (
  windowWidth,
  windowHeight,
  model
) => {
  const modelRatio = model.height / model.width;
  const windowRatio = windowHeight / windowWidth;
  let scaleWidth;
  let scaleHeight;

  if (windowRatio < modelRatio) {
    scaleHeight = windowHeight;
    scaleWidth = scaleHeight / modelRatio;
  } else {
    scaleWidth = windowWidth;
    scaleHeight = scaleWidth * modelRatio;
  }
  return {
    width: scaleWidth,
    height: scaleHeight
  };
};

export const calculateModelViewSizeWRTParentModel = (
  parentSize,
  parentModel,
  model
) => {
  const scaleRatio = parentSize.height / parentModel.height;
  return {
    width: model.width * scaleRatio,
    height: model.height * scaleRatio
  };
};

export const calculateRoomAndWallViewSize = (
  orgWindowWidth,
  orgWindowHeight,
  projectSize
) => (dispatch, getState) => {
  const { viewType } = getState().fabricCanvas;
  const { project } = getState().finalCheck;
  let windowWidth;
  let windowHeight;
  let roomWallSize;
  let canvasSize;

  if (dispatch(checkIfCanvasApp()) && viewType == Constants.TWO_D_TYPE) {
    windowWidth = orgWindowWidth;
    windowHeight = orgWindowHeight;
    canvasSize = calculateModelViewSizeWRTWindow(windowWidth, windowHeight, {
      width: projectSize.width,
      height: projectSize.height
    });
    roomWallSize = canvasSize;
  } else {
    windowWidth = orgWindowWidth - dispatch(getCanvasOffsetX());
    windowHeight = orgWindowHeight - dispatch(getCanvasOffsetY());
    roomWallSize = calculateModelViewSizeWRTWindow(
      windowWidth,
      windowHeight,
      project.activeWall
    );

    canvasSize = calculateModelViewSizeWRTParentModel(
      roomWallSize,
      project.activeWall,
      {
        width: projectSize.width,
        height: projectSize.height
      }
    );
  }
  return { windowWidth, windowHeight, roomWallSize, canvasSize };
};

export const scenePaddingInView = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const { projectHeight } = getState().home;
  const projectHeightScale = projectHeight / wallCanvas.height;
  return dispatch(scenePadding()) / projectHeightScale;
};

export const canvasSizeWithPadding = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const scenePaddingView = dispatch(scenePaddingInView());
  return {
    width: wallCanvas.width + scenePaddingView,
    height: wallCanvas.height + scenePaddingView
  };
};

export const updateWindowDimensions = (orgWindowWidth, orgWindowHeight) => (
  dispatch,
  getState
) => {
  const { projectWidth, projectHeight } = getState().home;
  const { windowWidth, windowHeight, roomWallSize, canvasSize } = dispatch(
    calculateRoomAndWallViewSize(orgWindowWidth, orgWindowHeight, {
      width: projectWidth,
      height: projectHeight
    })
  );

  if (dispatch(isRoomMode())) {
    const x = (roomWallSize.width - canvasSize.width) / 2;
    const y = (roomWallSize.height - canvasSize.height) / 2;
    dispatch(setDraggableCanvasPosition(x, y));
  }
  dispatch({
    type: actions.UPDATE_WINDOW_DIMENSIONS,
    payload: {
      orgWindowWidth,
      orgWindowHeight,
      windowWidth,
      windowHeight,
      canvasWallScaleWidth: roomWallSize.width,
      canvasWallScaleHeight: roomWallSize.height,
      projectScaleWidth: canvasSize.width,
      projectScaleHeight: canvasSize.height
    }
  });
  return Promise.resolve();
};

export const updateTextLoaderCoordinates = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const activeObject = wallCanvas.getActiveObject();
  const { id } = getState().sideBar.addText;

  // Edit text
  if (
    activeObject &&
    Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
    activeObject.placing.placeableType === Constants.TEXT_ELEMENT_TYPE &&
    id
  ) {
    const midPoints = getLoaderMidPoint(wallCanvas, activeObject);
    dispatch(
      setLoaderCoordinates({
        left: midPoints.leftValue,
        top: midPoints.topValue
      })
    );
  }
};

const getLoaderMidPoint = (canvas, oldText) => {
  const maxPointX = getMaxXPointOfObject(oldText);
  const minPointX = getMinXPointOfObject(oldText);
  const maxPointY = getMaxYPointOfObject(oldText);
  const minPointY = getMinYPointOfObject(oldText);

  const rotatedWidth = maxPointX - minPointX;
  const rotatedHeight = maxPointY - minPointY;

  const mql = window.matchMedia('(max-width: 767px)');
  let sidebarWidth = Constants.SIDE_BAR_WIDTH;
  if (mql.matches) {
    sidebarWidth = 0;
  }
  const left =
    canvas._offset.left - sidebarWidth - 8 + oldText.left + rotatedWidth / 2;
  const top =
    canvas._offset.top -
    Constants.HEADER_HEIGHT -
    8 +
    oldText.top +
    rotatedHeight / 2;

  return {
    leftValue: left,
    topValue: top
  };
};

export const convertToArrayFromColorDict = colorDictArray => {
  const colorsArray = [];
  if (colorDictArray) {
    colorDictArray.forEach(colorDict => {
      colorsArray.push(colorDict.hex);
    });
  }
  return colorsArray;
};

export const recolorTiledImage = (activeObject, recolorArray) => dispatch => {
  if (activeObject.placing.placeable.svgColors) {
    activeObject.placing.placeable.svgColors = recolorArray;
    activeObject.placing.placeable.isSvgRecolored = true;
  } else {
    activeObject.placing.placeableId = null;
    activeObject.placing.placeable.colors = recolorArray;
  }
  const recoloredPath = dispatch(getRecolrableImagePath(activeObject.placing));

  fabric.Image.fromURL(
    recoloredPath,
    img => {
      const offscreenCanvas = new fabric.Canvas();
      offscreenCanvas.setDimensions({
        width: activeObject.unTileObject.width,
        height: activeObject.unTileObject.height
      });

      img.scaleToWidth(activeObject.unTileObject.width);
      img.scaleToHeight(activeObject.unTileObject.height);
      img.setCoords();

      offscreenCanvas.add(img);
      offscreenCanvas.renderAll();
      const url = offscreenCanvas.toDataURL('image/png');

      //  On requesting for placeable details, response will not have this field. Hance hardcoding it
      activeObject.placing.placeable.tile = true;
      activeObject.placing.placeable.imagePath = url;
      dispatch(
        addBackgroundToCanvas(
          activeObject.placing,
          activeObject.scaleSliderValue,
          () => {}
        )
      );
    },
    {
      crossOrigin: 'Anonymous'
    }
  );
};

export const toggleDirtyBit = () => (dispatch, getState) => {
  const undoStackIndex = getState().fabricCanvas.undoInstance.getUndoStackIndex();
  dispatch({
    type: actions.MAKE_PROJECT_DIRTY,
    payload: {
      value: undoStackIndex
    }
  });
};

export const makeProjectDirtyWithNoUndoSupport = state => dispatch => {
  dispatch({
    type: actions.MAKE_PROJECT_DIRTY_WITH_NO_UNDO_SUPPORT,
    payload: {
      value: state
    }
  });
};

export const addToUndoManager = dict => (dispatch, getState) => {
  const undoManager = getState().fabricCanvas.undoInstance;
  undoManager.add(dict);
  dispatch(toggleDirtyBit());
};

export const recolorImage = (activeObject, recolorArray) => dispatch => {
  let oldRecolorArray;
  if (activeObject.placing.placeable.svgColors) {
    oldRecolorArray = activeObject.placing.placeable.svgColors;
  } else {
    oldRecolorArray = activeObject.placing.placeable.colors;
    // Need confirmation from backend people why do we need to set this... Right now doing as it is in Cappuccino
    activeObject.placing.placeableId = null;
  }
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(handleRecolorImage(activeObject, oldRecolorArray));
      },
      redo: () => {
        dispatch(handleRecolorImage(activeObject, recolorArray));
      }
    })
  );
  dispatch(handleRecolorImage(activeObject, recolorArray));
};

export const handleRecolorImage = (activeObject, recolorArray) => dispatch => {
  if (activeObject.placing.placeable.svgColors) {
    activeObject.placing.placeable.svgColors = recolorArray;
    activeObject.placing.placeable.isSvgRecolored = true;
  } else {
    activeObject.placing.placeable.colors = recolorArray;
  }
  const recoloredPath = dispatch(getRecolrableImagePath(activeObject.placing));
  fabric.Image.fromURL(
    recoloredPath,
    img => {
      const offscreenCanvas = new fabric.Canvas();
      let url = recoloredPath;
      if (
        activeObject.width != img.width ||
        activeObject.height != img.height
      ) {
        img.scaleToWidth(activeObject.width);
        img.scaleToHeight(activeObject.height);
        img.setCoords();
        offscreenCanvas.setDimensions({
          width: activeObject.width,
          height: activeObject.height
        });
        offscreenCanvas.add(img);
        offscreenCanvas.renderAll();
        url = offscreenCanvas.toDataURL('image/png');
      }
      if (dispatch(isSharedScene())) {
        dispatch(generatePreviewsOfSideWalls());
      }
      activeObject.setSrc(
        url,
        () => {
          activeObject.set({
            dirty: true
          });
          activeObject.placing.placeable.imagePath = url;
          const canvas = dispatch(getActiveCanvas(activeObject.placing));
          canvas.renderAll();
          dispatch(setLoadingState(null));
        },
        activeObject.toObject()
      );
    },
    {
      crossOrigin: 'Anonymous'
    }
  );
};

const isSvgRecolored = elementPlaceable => elementPlaceable.isSvgRecolored;

export const getRecolrableImagePath = placing => (dispatch, getState) => {
  const { placeable } = placing;
  const elementId =
    Object.prototype.hasOwnProperty.call(placeable, 'imageSource') &&
    (placeable.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE ||
      placeable.imageSource === Constants.UNSPLASH_IMAGE_SOURCE)
      ? placeable.mediaId
      : placeable.id;

  if (placeable.svgColors && isSvgRecolored(placeable)) {
    const colorsAsString = placeable.svgColors.toString();
    return `/content/user_photos/${elementId}/recolor_svg?colors=${colorsAsString}`;
  }
  if (placing.placeableType === Constants.USER_PHOTO_TYPE) {
    if (placeable.colors) {
      // In case of non-svg images,  if colors property is set that means it has been recolored
      const colorsArray = convertToArrayFromColorDict(placeable.colors);
      const colorsAsString = colorsArray.toString();
      const prefixURL = getState().modal.envData.redirect_url_on_load_error;
      if (placeable.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
        return `${prefixURL}/pattern_design_api/recolor?search_parameters[id]=${elementId}&search_parameters[colors]=${colorsAsString}&search_parameters[resolution]=1000`;
      }
    }
  }
  let parameter = `?${Date.now()}`;
  const { imagePath } = placeable;
  const questionMarkCharExists = imagePath.indexOf('?') >= 0;
  if (questionMarkCharExists) {
    parameter = `&${Date.now()}`;
  }
  return imagePath + parameter;
};

export const createSVGUserPhoto = (activeObject, recolorArray) => (
  dispatch,
  getState
) => {
  if (
    activeObject.placing.placeableType === Constants.USER_PHOTO_TYPE &&
    (activeObject.placing.imageSource === Constants.HP_MOSAIC_IMAGE_SOURCE ||
      activeObject.placing.imageSource ===
        Constants.HOSTED_CONTENT_IMAGE_SOURCE)
  ) {
    api
      .createUserPhotoForHostedContent(
        activeObject.placing.placeable.userPhotoType,
        activeObject.placing.placeable.mediaId,
        getState().modal.storeData.id,
        activeObject.placing.placeable.imageSource
      )
      .then(res => {
        dispatch(createdSVGUserPhoto(res, activeObject, recolorArray));
      })
      .catch(() => {
        dispatch(setLoadingState(null));
      });
  } else {
    const { placeableId } = activeObject.placing;

    api
      .createUserPhoto(
        activeObject.placing.placeableType,
        placeableId,
        getState().modal.storeData.id,
        activeObject.placing.svgReferenceId
      )
      .then(res => {
        dispatch(createdSVGUserPhoto(res, activeObject, recolorArray));
      })
      .catch(() => {
        dispatch(setLoadingState(null));
      });
  }
};

const createdSVGUserPhoto = (res, activeObject, recolorArray) => (
  dispatch,
  getState
) => {
  if (res.data.result === 'SUCCESS') {
    res.data.user_photo.theme_id = getState().modal.startUpScene.themeId;
    res.data.user_photo.theme_name = getState().modal.startUpScene.themeName;
    const userPhotoObj = new UserPhoto(res.data.user_photo);

    placeableIsUpdated(activeObject.placing, userPhotoObj);
    if (activeObject.placing.tiled) {
      dispatch(recolorTiledImage(activeObject, recolorArray));
    } else {
      dispatch(recolorImage(activeObject, recolorArray));
    }
  }
};

export const placeableIsUpdated = (placing, newUserPhoto) => {
  placing.placeable = newUserPhoto;
  copyPlaceable(placing, newUserPhoto);
};

const getInspirationWithId = inspirationId => (dispatch, getState) => {
  const inspirationArray = getState().sideBar.inspirations.portraitInspirations;
  let inspiration = null;

  const filteredArray = inspirationArray.filter(
    locInspiration => locInspiration.dataJSON.id === inspirationId
  );

  if (filteredArray.length > 0) {
    [inspiration] = filteredArray;
  }

  return inspiration;
};

export const isPlaceablePresentInInspiration = placeableId => (
  dispatch,
  getState
) => {
  const projectParentId = getState().finalCheck.project.parentId;
  if (projectParentId && placeableId) {
    const inspiration = dispatch(getInspirationWithId(projectParentId));
    if (inspiration === null) {
      return false;
    }
    const placingsOfInspiration = inspiration.dataJSON.placings;
    const matchedPlaicngs = placingsOfInspiration.filter(
      placing => placing.placeable_id == placeableId
    );
    if (matchedPlaicngs.length > 0) {
      return true;
    }
  }
  return false;
};

export const updateElementWithColorsArray = recolorArray => (
  dispatch,
  getState
) => {
  /* While recoloring if object is not user photo and is svg image => then convert it into new userPhoto.If it is non svg image  => then make placeable_id as nil so that after recoloring it should be as a new object and original object will not be effected
  But my query is do we have to do the same if project is opened via edit link... since object recolor should update the original object.
  Discuss this with ROR team
  */
  dispatch(setLoadingState(string.RECOLORING_KEY));
  const { activeObject } = getState().fabricCanvas;
  dispatch(gaForCanvasAction(activeObject.placing, true));

  //  If recolored in this session then do not add 123456 field.
  activeObject.placing.isRecoloredInThisSession = true;

  if (
    (activeObject.placing.placeableType === Constants.ELEMENT_KEY ||
      activeObject.placing.placeableType === Constants.SCENE_KEY ||
      dispatch(
        isPlaceablePresentInInspiration(activeObject.placing.placeableId)
      ) ||
      (activeObject.placing.placeableType === Constants.USER_PHOTO_TYPE &&
        (activeObject.placing.imageSource ===
          Constants.HP_MOSAIC_IMAGE_SOURCE ||
          activeObject.placing.imageSource ===
            Constants.HOSTED_CONTENT_IMAGE_SOURCE) &&
        !isSvgRecolored(activeObject.placing))) &&
    activeObject.placing.placeable.svgColors
  ) {
    dispatch(setSvgReferenceId(activeObject));
    dispatch(createSVGUserPhoto(activeObject, recolorArray));
  } else if (activeObject.placing.tiled) {
    dispatch(recolorTiledImage(activeObject, recolorArray));
  } else {
    dispatch(recolorImage(activeObject, recolorArray));
  }
};

export const setSvgReferenceId = activeObject => (dispatch, getState) => {
  let svgRefId = getState().fabricCanvas.svgReferenceId;
  svgRefId = svgRefId ? svgRefId + 1 : 1;
  if (Object.prototype.hasOwnProperty.call(activeObject, 'placing')) {
    activeObject.placing.svgReferenceId = svgRefId;
  }
  dispatch({
    type: actions.SET_SVG_REFERENCE_ID,
    payload: { svgReferenceId: svgRefId }
  });
};

export const cloneForUploadContents = (element, properties) => (
  dispatch,
  getState
) => {
  const clonedObject = JSON.parse(JSON.stringify(element));
  const isSignage = isSignageSuiteProduct();
  if (
    isSignage &&
    getState().fabricCanvas.viewType === Constants.THREE_D_TYPE
  ) {
    dispatch(setViewMode(Constants.TWO_D_TYPE));
  }

  dispatch(addToCanvas(clonedObject, properties));
};

export const setSidebarVisibility = state => dispatch => {
  dispatch({
    type: actions.SET_SIDEBAR_VISIBILITY,
    payload: { value: state }
  });
};

export const showNonEditableAlert = () => dispatch => {
  const dict = {
    header: Constants.NON_EDITABLE_ALERT_HEADER,
    description: Constants.NON_EDITABLE_ALERT_BODY,
    stringColor: Constants.DEFAULT_STRING_COLOR,
    onclick: () => {},
    buttonTitles: {
      finish: string.OK_KEY,
      cancel: ''
    }
  };
  dispatch(setMessageDialogParams(dict));
};

export const continueAddToCanvas = (placing, properties, callback) => (
  dispatch,
  getState
) => {
  const canvas = dispatch(getActiveCanvas(placing));
  placing.storeId = getState().modal.storeData.id;

  if (isBackgroundTypeElement(placing)) {
    dispatch(setScenePlacingToProject(placing));
  } else if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
    let oldPlacing = null;
    canvas.getObjects().forEach(obj => {
      // Check if text added is in edit text flow
      if (
        obj.placing.placeableType == Constants.TEXT_ELEMENT_TYPE &&
        obj.placing.placeableId == placing.placeable.id &&
        !properties.isDuplicate
      ) {
        oldPlacing = obj.placing;
      }
    });
    if (oldPlacing) {
      placing.id = oldPlacing.id;
      placing.wallId = oldPlacing.wallId;
      dispatch(replacePlacing(oldPlacing, placing));
    } else {
      dispatch(addPlacingToProject(placing));
    }
  } else {
    dispatch(addPlacingToProject(placing));
  }

  if (canvas) {
    if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
      placing.isDuplicate = properties.isDuplicate;
      dispatch(
        addTextToCanvas(placing, () => {
          if (placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
            dispatch(handleUploadDialogueState(false));
            dispatch(setLoadingState(null));
            dispatch({
              type: actions.SET_LOADER_STATE,
              payload: {
                buttonState: false,
                loaderState: 'd-none'
              }
            });
            dispatch(
              setLoaderCoordinates({
                left: null,
                top: null
              })
            );
          }
        })
      );
    } else if (isBackgroundTypeElement(placing)) {
      if (getState().sideBar.activeTheme) {
        placing.themeId = getState().sideBar.activeTheme.id;
        placing.themeName = getState().sideBar.activeTheme.name;
        placing.externalPlaceable = getState().sideBar.activeTheme.isExternalContent;
      } else if (placing.placeableType != Constants.WALL_LAYOUT_KEY) {
        placing.themeId = getState().modal.startUpScene.themeId;
        placing.themeName = getState().modal.startUpScene.themeName;
        placing.externalPlaceable = false;
      }

      let defaultScaleSliderValue = 0;
      const { partnerStoreType } = getState().modal.storeData;
      const projectCategory = getState().modal.envData.category;
      if (
        tieleValue(placing.placeable) &&
        !isARCEnabled(projectCategory, partnerStoreType)
      ) {
        defaultScaleSliderValue = Constants.DEFAULT_TILED_SCALE;
      }
      dispatch(
        addBackgroundToCanvas(placing, defaultScaleSliderValue, callback)
      );
    } else {
      if (getState().sideBar.activeTheme) {
        placing.themeId = getState().sideBar.activeTheme.id;
        placing.themeName = getState().sideBar.activeTheme.name;
        placing.externalPlaceable = getState().sideBar.activeTheme.isExternalContent;
      } else {
        placing.themeId = getState().modal.startUpScene.themeId;
        placing.themeName = getState().modal.startUpScene.themeName;
        placing.externalPlaceable = false;
      }
      dispatch(addElementToCanvas(placing, properties, () => {}));
    }
    canvas.renderAll();

    dispatch(gaForCanvasAction(placing, false));
  }
};

export const addToCanvas = (placeable, properties, callback) => (
  dispatch,
  getState
) => {
  dispatch(setSidebarVisibility(false));

  if (dispatch(isNonEditableInspiration())) {
    dispatch(showNonEditableAlert());
    dispatch({
      type: actions.SET_LOADER_STATE,
      payload: {
        buttonState: false,
        loaderState: 'd-none'
      }
    });
    dispatch(resetTextTemplate());
    return;
  }
  const placing = new Placing(placeable);
  if (dispatch(checkIfStickersTypeApp())) {
    placing.groupId = getState().sticker.activeStickerId;
  }
  if (isBackgroundTypeElement(placing)) {
    if (dispatch(canShowtemplateSelectionDialogueIn3D())) {
      const backupData = {
        placing,
        properties,
        callback
      };
      dispatch(showOrHideTemplateSelectionDialogue(true, backupData));
    } else if (placing.tiled && dispatch(isSharedScene())) {
      const { project } = getState().finalCheck;
      dispatch(setSharedSceneTo(project, false));
      dispatch(unstretchSideProjects());
      dispatch(continueAddToCanvas(placing, properties, callback));
    } else {
      dispatch(setScenePlacingOffsetAndSize(placing));
      dispatch(continueAddToCanvas(placing, properties, callback));
    }
  } else {
    dispatch(continueAddToCanvas(placing, properties, callback));
  }
};

export const setScenePlacingOffsetAndSize = placing => (dispatch, getState) => {
  if (!placing.tiled) {
    const { projectHeight } = getState().home;
    const { placeable } = placing;
    placing.width = dispatch(
      minimumSceneWidth(placeable.width, placeable.height)
    );
    placing.height = dispatch(
      minimumSceneHeight(placeable.width, placeable.height)
    );
    placing.xOffset =
      (dispatch(getMultiProjectsWidth()) - placing.width) / 2 -
      dispatch(getModelLeftProjectsWidth());
    placing.yOffset = (projectHeight - placing.height) / 2;
  }
};

export const isBackgroundTypeElement = placing =>
  (placing && placing.placeableType === Constants.SCENE_KEY) ||
  (placing.placeableType === Constants.USER_PHOTO_TYPE &&
    placing.userPhotoType === Constants.USER_PHOTO_SCENE_TYPE);

export const removeLoadingRect = e => (dispatch, getState) => {
  const { wallCanvas, roomCanvas } = getState().fabricCanvas;
  if (Object.prototype.hasOwnProperty.call(e.target, 'loadingRect')) {
    if (wallCanvas.getObjects().includes(e.target.loadingRect)) {
      wallCanvas.remove(e.target.loadingRect);
    }
    if (roomCanvas.getObjects().includes(e.target.loadingRect)) {
      roomCanvas.remove(e.target.loadingRect);
    }
  }
};

export const indexOfElement = element => dispatch => {
  const canvas = dispatch(getActiveCanvas(element.placing));
  let index = -1;
  let matchingIndex = -1;
  canvas.getObjects().forEach(obj => {
    index++;
    if (matchingIndex === -1 && obj === element) {
      matchingIndex = index;
    }
  });

  return matchingIndex;
};

export const duplicateText = () => (dispatch, getState) => {
  getState().sideBar.addText.id = null;
  dispatch(submitAddText(null, true));
};

export const setBoundsAndOriginForElement = (
  element,
  canvas,
  left,
  top,
  xScale,
  yScale,
  rotationAngle,
  wt,
  ht,
  originX,
  originY
) => dispatch => {
  element.set({
    left,
    top
  });
  element.scaleX = xScale;
  element.scaleY = yScale;
  element.width = wt;
  element.height = ht;
  element.angle = rotationAngle;
  element.originX = originX;
  element.originY = originY;
  element.setCoords();
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const getElementImagePath = placing => dispatch => {
  const { placeable } = placing;
  const newPath = placeable.imagePath;
  if (placeable.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE) {
    return placeable.croppedImagePath;
  }
  if (
    placeable.svgColors &&
    placeable.svgColors.length &&
    placeable.isSvgRecolored
  ) {
    if (placing.isRecoloredInThisSession) {
      return dispatch(getRecolrableImagePath(placing));
    }
    return appendTimeStampToPath(newPath);
  }
  if (placeable.colors && placeable.colors.length) {
    if (!placing.isRecoloredInThisSession) {
      return dispatch(getRecolrableImagePath(placing));
    }
    return newPath;
  }
  return appendTimeStampToPath(newPath);
};

export const appendTimeStampToPath = path => {
  if (path) {
    let parameter = `?${Date.now()}`;
    if (path && path.indexOf('?') >= 0) {
      parameter = `&${Date.now()}`;
    }
    return path + parameter;
  }
  return path;
};

export const addBackgroundElement = (element, canvas) => (
  dispatch,
  getState
) => {
  //  Replace existing background
  let prevBGElement = null;
  canvas.forEachObject(object => {
    if (isBackground(object)) {
      prevBGElement = object;
    }
  });
  let isGrouped = false;
  if (prevBGElement !== element) {
    const undoManager = getState().fabricCanvas.undoInstance;
    undoManager.beginGroup();
    isGrouped = true;
    if (prevBGElement !== null) {
      canvas.remove(prevBGElement);
      canvas.renderAll();
      dispatch(toggleDirtyBit());

      //   dispatch(removeElement(prevBGElement));
      dispatch(
        addToUndoManager({
          undo: () => {
            dispatch(addElementWithPlacing(prevBGElement));
          },
          redo: () => {
            dispatch(deleteCanavsElement(prevBGElement));
          }
        })
      );
    }

    dispatch(addElement(element, false));
    dispatch(didAddObjectOnCreation(element));
    if (isGrouped) {
      undoManager.endGroup();
    }
    dispatch(generatePreviewsOfSideWalls());
  } else {
    canvas.renderAll();
  }
};

export const getCanvasArrayIndexFromZIndex = element => dispatch => {
  const canvas = dispatch(getActiveCanvas(element.placing));
  const objects = canvas.getObjects();
  let arrayIndex = 0;
  for (let i = 0; i < objects.length; i++) {
    if (
      Object.prototype.hasOwnProperty.call(objects[i], 'placing') &&
      (Object.prototype.hasOwnProperty.call(element, 'loadingRect') ||
        element.placing.placeableType == Constants.TEXT_ELEMENT_TYPE ||
        element.placing.placeableType == Constants.SOLID_FILL_KEY)
    ) {
      const { placing } = objects[i];
      if (element.placing.zIndex && element.placing.zIndex <= placing.zIndex) {
        return arrayIndex;
      }
      arrayIndex++;
    }
  }
  return arrayIndex;
};

export const addElement = (element, shouldSelect) => (dispatch, getState) => {
  const canvas = dispatch(getActiveCanvas(element.placing));
  if (isBackground(element)) {
    if (isImageBasedBackground(element)) {
      getState().finalCheck.project.backgroundColor = null;
    } else if (element.placing.placeable.type === Constants.SOLID_FILL_KEY) {
      getState().finalCheck.project.backgroundColor =
        element.placing.placeable.color;
      const startUpScenePlacing = dispatch(getStartupScenePlacing());
      dispatch(setScenePlacingToProject(startUpScenePlacing));
    }
    dispatch(insertElement(element, 0));
  } else {
    const arrayIndex = dispatch(getCanvasArrayIndexFromZIndex(element));
    dispatch(updateStickerIdList(element.placing.groupId));
    dispatch(insertElement(element, arrayIndex));
    canvas.renderAll();
    dispatch(toggleDirtyBit());
  }
  if (shouldSelect) {
    dispatch(selectObject(element));
  }
  dispatch(updateProjectPlacingsCoords());
  dispatch(generatePreviewOfStickers());
};

export const insertElement = (element, index) => dispatch => {
  const canvas = dispatch(getActiveCanvas(element.placing));
  if (index >= canvas.getObjects().count) {
    canvas.add(element);
  } else {
    canvas.insertAt(element, index);
  }
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const removeElement = element => dispatch => {
  const canvas = dispatch(getActiveCanvas(element.placing));
  canvas.discardActiveObject();
  canvas.remove(element);
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const handleDeleteKey = element => dispatch => {
  if (element.type === 'activeSelection') {
    element.forEachObject(ele => {
      dispatch(deleteAction(ele));
    });
  } else {
    dispatch(deleteAction(element));
  }
};

export const deleteCanavsElement = element => dispatch => {
  if (element.placing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
    dispatch(resetTextTemplate());
  }

  dispatch(destroyElement(element));
  if (isImageBasedBackground(element)) {
    dispatch(generatePreviewsOfSideWalls());
  }
  dispatch(selectObject(null));
  dispatch(setFilteredTools([]));
  dispatch(generatePreviewOfStickers());
};

export const destroyElement = element => (dispatch, getState) => {
  if (isBackground(element)) {
    if (element.placing.placeable.type === Constants.SOLID_FILL_KEY) {
      getState().finalCheck.project.backgroundColor = null;
    }
    if (dispatch(shouldSelectFirstSceneOfFirstTheme())) {
      const data = dispatch(getFirstTheme());
      if (
        data &&
        Object.prototype.hasOwnProperty.call(element, 'placing') &&
        data.elements[0]
      ) {
        if (element.placing.placeableId == data.elements[0].id) {
          return;
        }
        dispatch(addToCanvas(data.elements[0]));
      }
    } else {
      const startUpScenePlacing = dispatch(getStartupScenePlacing());
      dispatch(setScenePlacingToProject(startUpScenePlacing));
    }
  } else {
    dispatch(removePlacingFromProject(element.placing));
  }
  dispatch(removeElement(element));
};

export const scaleElements = (inScale, canvas) => () => {
  const scale = parseFloat(inScale).toFixed(2);
  const elementScaleRatio =
    Constants.MINIMUM_ZOOM_VALUE +
    (scale * (Constants.MAXIMUM_ZOOM_VALUE - Constants.SLIDER_MIN_VALUE)) /
      Constants.SLIDER_MAX_VALUE;

  const onlyElements = canvasElementsExceptBackground(canvas);
  onlyElements.forEach(ele => {
    const newScaleX = elementScaleRatio * ele.scaleX;
    ele.scale(newScaleX).setCoords();
    ele.left *= elementScaleRatio;
    ele.top *= elementScaleRatio;
    ele.setCoords();
  });
  canvas.renderAll();
};

export const objectRotated = e => (dispatch, getState) => {
  if (e.target !== null) {
    const undoManager = getState().fabricCanvas.undoInstance;
    if (undoManager.getUndoEnableState() === true) {
      dispatch(saveStates(e));
    }
    dispatch(updatePlacingCoords(e.target));
  }
};

export const addCanvasObjectOnCreation = e => dispatch => {
  dispatch(addElement(e, false));
  dispatch(didAddObjectOnCreation(e));
};

export const setScenePlacingToProject = placing => (dispatch, getState) => {
  if (placing) {
    const { project, activeMultiWallProjectIndex } = getState().finalCheck;
    placing.wallId = project.activeWall.id;
    placing.wallIndex = project.wallIndex;

    const scenePlacing = activeScenePlacing(project);
    const oldScenePlacingId = scenePlacing ? scenePlacing.id : null;
    placing.id = oldScenePlacingId;
    addScenePlacing(project, placing);
    dispatch({
      type: actions.SET_SHARED_SCENE_DATA,
      payload: {
        sharedSceneData: { placing, projectIndex: activeMultiWallProjectIndex }
      }
    });
  }
};

export const addPlacingToProject = placing => (dispatch, getState) => {
  if (placing) {
    const { project } = getState().finalCheck;
    placing.wallId = project.activeWall.id;
    placing.wallIndex = project.wallIndex;
    if (placing.placeableType == Constants.WALL_LAYOUT_KEY) {
      project.activeWall.placings.push(placing);
    } else {
      project.elementPlacings.push(placing);
    }
  }
};

export const replacePlacing = (oldPlacing, newPlaing) => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  newPlaing.wallIndex = oldPlacing.wallIndex;
  if (dispatch(checkIfStickersTypeApp())) {
    newPlaing.groupId = getState().sticker.activeStickerId;
  }
  const sceneIndex = project.scenePlacings.indexOf(oldPlacing);
  if (sceneIndex >= 0) {
    project.scenePlacings[sceneIndex] = newPlaing;
  }

  const eleIndex = project.elementPlacings.indexOf(oldPlacing);
  if (eleIndex >= 0) {
    project.elementPlacings[eleIndex] = newPlaing;
  }
};

export const removePlacingFromProject = placing => (dispatch, getState) => {
  if (placing.placeableType == Constants.WALL_LAYOUT_KEY) {
    if (placing.id) {
      getState().finalCheck.project.activeWall.removedPlacings.push(placing);
    }
    let tempPlacings = getState().finalCheck.project.activeWall.placings;
    tempPlacings = tempPlacings.filter(iPlacing => iPlacing !== placing);
    getState().finalCheck.project.activeWall.placings = tempPlacings;
  } else {
    if (placing.id) {
      getState().finalCheck.project.removedPlacings.push(placing);
    }
    let tempPlacings = getState().finalCheck.project.elementPlacings;
    tempPlacings = tempPlacings.filter(iPlacing => iPlacing !== placing);
    getState().finalCheck.project.elementPlacings = tempPlacings;
    dispatch(checkForMappedPlacings(placing));
  }
};

export const didAddObjectOnCreation = e => dispatch => {
  const activeObject = e;
  dispatch(selectObject(e));
  dispatch(checkForElementsControls());

  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(deleteCanavsElement(activeObject));
      },
      redo: () => {
        dispatch(addElementWithPlacing(activeObject));
      }
    })
  );
};

export const addElementWithPlacing = element => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  if (isBackground(element)) {
    if (isImageBasedBackground(element)) {
      dispatch(setScenePlacingToProject(element.placing));
    }
  } else {
    dispatch(addPlacingToProject(element.placing));
  }
  project.removedPlacings = project.removedPlacings.filter(
    placing => placing.id != element.placing.id
  );
  project.walls.forEach(wall => {
    wall.removedPlacings = wall.removedPlacings.filter(
      placing => placing.id != element.placing.id
    );
  });
  project.elementPlacings.sort((a, b) => (a.zIndex > b.zIndex ? 1 : -1));
  dispatch(addElement(element, true));
};

export const canDisableCanvasDrag = () => (dispatch, getState) => {
  const { activeObject } = getState().fabricCanvas;
  return (
    activeObject &&
    activeObject.placing &&
    activeObject.placing.placeableType == Constants.PROJECT_KEY &&
    activeObject.placing.locked
  );
};

export const selectObject = e => dispatch => {
  if (
    e !== null &&
    ((e.placing.locked && !dispatch(checkIfStickersTypeApp())) ||
      dispatch(isNonEditableInspiration()) ||
      (dispatch(isRoomMode()) &&
        !isWallLayout(e) &&
        e.placing.placeableType != Constants.PROJECT_KEY))
  ) {
    return;
  }
  const placingObj = e ? e.placing : null;
  const canvas = dispatch(getActiveCanvas(placingObj));
  if (e !== null && e.placing.placeableType != Constants.PROJECT_KEY) {
    canvas.setActiveObject(e);
    const pixelationIsHidden = dispatch(checkForPixelationWarning(e));
    e.set({
      hasPixelationWarning: pixelationIsHidden
    });
  }
  dispatch(activeObjectHandler(e));
  canvas.renderAll();
};

export const mouseDownOnObject = targetObj => (dispatch, getState) => {
  const { activeObject } = getState().fabricCanvas;

  if (
    dispatch(isStickerWorkspaceMode()) &&
    targetObj &&
    targetObj != activeObject
  ) {
    const canvas = dispatch(getActiveCanvas(targetObj.placing));
    const groupedObjects = [...canvas.getObjects()];
    const isSingleObjectSticker =
      groupedObjects.length == 1 && groupedObjects[0] == targetObj;
    if (!isSingleObjectSticker) {
      dispatch(enebaleOrDisableStickerDrag(false));
    }
    dispatch({
      type: actions.SET_SELECTED_OBJECTS,
      payload: {
        selectedObjects: groupedObjects
      }
    });
    canvas.discardActiveObject();
    if (groupedObjects.length < 1) return;
    const selection = new fabric.ActiveSelection(groupedObjects, {
      canvas
    });
    selection.type = 'activeSelection';
    selection.set({ hasRotatingPoint: false });
    canvas.setActiveObject(selection);
    dispatch(generatePreviewOfStickers());
    dispatch(activeObjectHandler(selection));

    dispatch(toolBarRerender());
    canvas.renderAll();
  } else {
    dispatch(activeObjectHandler(targetObj));
  }
};

export const activeObjectHandler = selectedObject => (dispatch, getState) => {
  const { activeObject } = getState().fabricCanvas;

  dispatch({
    type: actions.SET_PREVIOUS_ACTIVE_OBJECT,
    payload: { previousActiveObject: activeObject }
  });

  if (
    !selectedObject ||
    (Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
      isBackgroundTypeElement(selectedObject.placing))
  ) {
    dispatch({
      type: actions.SET_ACTIVE_SELECTION,
      payload: {
        activeSelection: null
      }
    });
  }
  dispatch(objectIsSelected(selectedObject));
  dispatch({
    type: actions.SET_ACTIVE_OBJECT,
    payload: {
      activeObject: selectedObject
    }
  });
  dispatch(addOrRemoveMeasurementLines(selectedObject));
  dispatch(checkForPixelationWarning(selectedObject));
};

export const objectResized = e => (dispatch, getState) => {
  if (e.target !== null) {
    const undoManager = getState().fabricCanvas.undoInstance;
    if (undoManager.getUndoEnableState() === true) {
      dispatch(saveStates(e));
    }
    dispatch(checkObjectForPixelation(e.target));
    dispatch(updateMeasurementLines(e.target));
  }
};

export const updateMeasurementLines = canvasObject => (dispatch, getState) => {
  const { projectWidth, projectHeight, unitSystem } = getState().home;
  if (canvasObject) {
    const canvas = dispatch(getActiveCanvas(canvasObject.placing));

    if (isWallLayout(canvasObject)) {
      refreshMeasurementLines(
        canvasObject,
        canvas,
        {
          projectWidth,
          projectHeight
        },
        unitSystem
      );
    }
  }
};

export const addOrRemoveMeasurementLines = canvasObject => (
  dispatch,
  getState
) => {
  const { projectWidth, projectHeight, unitSystem } = getState().home;
  const { previousActiveObject } = getState().fabricCanvas;
  if (isWallLayout(previousActiveObject)) {
    const prevPlacingObj = previousActiveObject
      ? previousActiveObject.placing
      : null;
    const prevCanvas = dispatch(getActiveCanvas(prevPlacingObj));
    removeMeasurementLines(previousActiveObject, prevCanvas);
  }
  const placingObj = canvasObject ? canvasObject.placing : null;
  const canvas = dispatch(getActiveCanvas(placingObj));
  if (isWallLayout(canvasObject)) {
    addMeasurementLines(
      canvasObject,
      canvas,
      {
        projectWidth,
        projectHeight
      },
      unitSystem
    );
  }
};

export const objectDragged = e => (dispatch, getState) => {
  const { undoInstance, isGrouped } = getState().fabricCanvas;
  if (e.target !== null) {
    if (e.target.type == 'activeSelection') {
      const { newX, newY } = dispatch(stickerBoundaryPoints(e.target));
      e.target.set({
        left: newX,
        top: newY
      });
      e.target.setCoords();
    } else {
      dispatch(boundSceneToCanvas(e));
      dispatch(updateMeasurementLines(e.target));
      const undoManager = undoInstance;
      if (undoManager.getUndoEnableState() === true || isGrouped) {
        dispatch(saveStates(e));
      }
      dispatch(updatePlacingCoords(e.target));
    }
  }
};

export const canvasObjectSizeIsUpdated = (canvasObject, inPosition, inSize) => (
  dispatch,
  getState
) => {
  const canvas = dispatch(getActiveCanvas(canvasObject.placing));

  const roomScale =
    getState().finalCheck.project.activeWall.height / canvas.height;

  let newLeft = inPosition.left / roomScale;
  let newTop = inPosition.top / roomScale;
  let newWidth = inSize.width / roomScale;
  let newHeight = inSize.height / roomScale;

  const unitType = getState().home.unitSystem;
  if (unitType === Constants.METRIC_KEY) {
    newLeft = convertFromMetricToImperial(newLeft);
    newTop = convertFromMetricToImperial(newTop);
    newWidth = convertFromMetricToImperial(newWidth);
    newHeight = convertFromMetricToImperial(newHeight);
  }

  const newScaleX = newWidth / canvasObject.width;
  const newScaleY = newHeight / canvasObject.height;

  canvasObject.set({
    scaleX: newScaleX,
    scaleY: newScaleY
  });

  canvasObject.set({
    left: newLeft,
    top: newTop
  });

  canvasObject.setCoords();
  canvas.renderAll();

  dispatch(updateMeasurementLines(canvasObject));
};

export const sceneBoundaryPoints = element => dispatch => {
  const rightWithCurrentProjectsWidth = dispatch(
    getRightWithCurrentProjectsWidth()
  );
  const leftProjectsWidth = dispatch(getLeftProjectsWidth());

  const canvas = dispatch(getActiveCanvas(element.placing));
  const scenePaddingView = dispatch(scenePaddingInView());

  let newX = element.left;
  let newY = element.top;

  // When drag scene from left to right restricting point on left
  const leftBound = 0 - leftProjectsWidth - scenePaddingView / 2;
  // When drag scene from right to left restricting point on left
  const rightBound =
    element.getScaledWidth() -
    rightWithCurrentProjectsWidth -
    scenePaddingView / 2;

  if (element.left > leftBound) {
    newX = leftBound;
  } else if (-element.left > rightBound) {
    newX = -rightBound;
  }

  // When drag scene from top to bottom restricting point on top
  const topBound = 0 - scenePaddingView / 2;
  // When drag scene from bottom to top restricting point on top
  const bottomBound =
    element.getScaledHeight() - canvas.height - scenePaddingView / 2;

  if (element.top > topBound) {
    newY = topBound;
  } else if (-element.top > bottomBound) {
    newY = -bottomBound;
  }
  return { newX, newY };
};

export const stickerBoundaryPoints = element => dispatch => {
  const canvas = dispatch(getActiveCanvas(element.placing));

  let newX = element.left;
  let newY = element.top;

  const leftBound = 0;
  const topBound = 0;
  const rightBound = canvas.width;
  const bottomBound = canvas.height;

  if (element.left < leftBound) {
    newX = leftBound;
  } else if (element.left + element.getScaledWidth() > rightBound) {
    newX = rightBound - element.getScaledWidth();
  }

  if (element.top < topBound) {
    newY = topBound;
  } else if (element.top + element.getScaledHeight() > bottomBound) {
    newY = bottomBound - element.getScaledHeight();
  }
  return { newX, newY };
};

export const boundSceneToCanvas = e => (dispatch, getState) => {
  const { draggedPosition, isGrouped } = getState().fabricCanvas;
  const canvas = dispatch(getActiveCanvas(e.target.placing));

  if (isBackground(e.target)) {
    const { newX, newY } = dispatch(sceneBoundaryPoints(e.target));
    dispatch(setPositionForElement(e.target, canvas, newX, newY));
    if (isGrouped) {
      const xDiff = draggedPosition.left - e.target.left;
      const yDiff = draggedPosition.top - e.target.top;
      const onlyElements = canvasElementsExceptBackground(canvas);
      onlyElements.forEach(element => {
        dispatch(
          setPositionForElement(
            element,
            canvas,
            element.left - xDiff,
            element.top - yDiff
          )
        );
      });
    }

    canvas.renderAll();
  }
  if (dispatch(checkIfStickersTypeApp())) {
    const { newX, newY } = dispatch(stickerBoundaryPoints(e.target));
    dispatch(setPositionForElement(e.target, canvas, newX, newY));
  }
  if (isFurnitureLayout(e.target)) {
    dispatch(
      setPositionForElement(
        e.target,
        canvas,
        e.target.left,
        canvas.height - e.target.getScaledHeight()
      )
    );
    canvas.renderAll();
  }
};

export const saveStates = e => (dispatch, getState) => {
  if (e.target !== null) {
    const activeObject = e.target; //  obtain active object
    const { isGrouped } = getState().fabricCanvas;
    const canvas = dispatch(getActiveCanvas(activeObject.placing));

    const positionValues = {
      //  obtain its position
      left: activeObject.left,
      top: activeObject.top,
      angle: activeObject.angle,
      width: activeObject.width,
      height: activeObject.height,
      scaleX: activeObject.scaleX,
      scaleY: activeObject.scaleY,
      scaleSlider: activeObject.scaleSliderValue,
      object: activeObject
    };
    dispatch({
      //  store state
      type: actions.SET_DRAGGED_POSITION,
      payload: {
        draggedPosition: positionValues
      }
    });
    changeObjectBorderColor(activeObject, dispatch);

    const undoManager = getState().fabricCanvas.undoInstance;
    undoManager.beginGroup();

    const prevScaleX = e.target.scaleX;
    const prevScaleY = e.target.scaleY;
    const prevLeft = e.target.left;
    const prevTop = e.target.top;
    const prevWidth = e.target.width;
    const prevHeight = e.target.height;
    const prevAngle = e.target.angle;

    dispatch(
      addToUndoManager({
        undo: () => {
          dispatch(
            setBoundsForElement(
              activeObject,
              canvas,
              prevLeft,
              prevTop,
              prevScaleX,
              prevScaleY,
              prevAngle,
              prevWidth,
              prevHeight
            )
          );
        },
        redo: () => {}
      })
    );

    if (isImageBasedBackground(e.target) && isGrouped) {
      const onlyElements = canvasElementsExceptBackground(canvas);
      onlyElements.forEach(element => {
        const prevElemScaleX = element.scaleX;
        const prevElemScaleY = element.scaleY;
        const prevElemLeft = element.left;
        const prevElemTop = element.top;
        const prevElmWidth = element.width;
        const prevElmHeight = element.height;
        const prevElmAngle = element.angle;

        dispatch(
          addToUndoManager({
            undo: () => {
              dispatch(
                setBoundsForElement(
                  element,
                  canvas,
                  prevElemLeft,
                  prevElemTop,
                  prevElemScaleX,
                  prevElemScaleY,
                  prevElmAngle,
                  prevElmWidth,
                  prevElmHeight
                )
              );
            },
            redo: () => {}
          })
        );
      });
    }
    undoManager.disableUndo();
  } else {
    fabric.Object.prototype.set({
      cornerColor: 'rgb(128,128,128)',
      borderColor: 'rgb(128,128,128)'
    });
    dispatch(setShowPixelationWarningField(false));
  }
};

export const mouseDown = e => dispatch => {
  if (e.target !== null) {
    const activeObject = e.target; //  obtain active object
    dispatch(saveStates(e));
    dispatch(setControlEdges(activeObject));
    changeObjectBorderColor(activeObject, dispatch);
  }
};

export const mouseUp = e => (dispatch, getState) => {
  dispatch(enebaleOrDisableStickerDrag(true));
  dispatch(toolBarRerender());
  if (
    e.target !== null &&
    e.target.placing &&
    e.target.placing.placeableType === Constants.TEXT_ELEMENT_TYPE &&
    !dispatch(isNonEditableInspiration())
  ) {
    dispatch(handleTabChange(Constants.TEXT_ELEMENT_TYPE));
  }

  if (e.target !== null) {
    const { isGrouped } = getState().fabricCanvas;
    const canvas = dispatch(getActiveCanvas(e.target.placing));
    const activeObject = e.target; //  obtain active object
    const undoManager = getState().fabricCanvas.undoInstance;
    if (undoManager.getUndoEnableState() === false) {
      undoManager.enableUndo();

      const newScaleX = e.target.scaleX;
      const newScaleY = e.target.scaleY;
      const newLeft = e.target.left;
      const newTop = e.target.top;
      const newWidth = e.target.width;
      const newHeight = e.target.height;
      const newAngle = e.target.angle;

      dispatch(
        addToUndoManager({
          undo: () => {},
          redo: () => {
            dispatch(
              setBoundsForElement(
                activeObject,
                canvas,
                newLeft,
                newTop,
                newScaleX,
                newScaleY,
                newAngle,
                newWidth,
                newHeight
              )
            );
          }
        })
      );

      if (isImageBasedBackground(e.target)) {
        dispatch(generatePreviewsOfSideWalls());
        if (isGrouped) {
          const onlyElements = canvasElementsExceptBackground(canvas);
          onlyElements.forEach(element => {
            const newElemScaleX = element.scaleX;
            const newElemScaleY = element.scaleY;
            const newElemLeft = element.left;
            const newElemTop = element.top;
            const newElmWidth = element.width;
            const newElmHeight = element.height;
            const newElmAngle = element.angle;

            dispatch(
              addToUndoManager({
                undo: () => {},
                redo: () => {
                  dispatch(
                    setBoundsForElement(
                      element,
                      canvas,
                      newElemLeft,
                      newElemTop,
                      newElemScaleX,
                      newElemScaleY,
                      newElmAngle,
                      newElmWidth,
                      newElmHeight
                    )
                  );
                }
              })
            );
          });
        }
      }
      undoManager.endGroup();
    }
  }
};

export const enableOrDisableObject = (object, canDisable) => {
  object.hasControls = !canDisable;
  object.lockMovementY = canDisable;
  object.lockMovementX = canDisable;
};

const checkForElementsControlsOfCanvas = canvas => (dispatch, getState) => {
  const { isGrouped, activeObject } = getState().fabricCanvas;
  const { canDragSticker } = getState().sticker;
  const onlyElements = canvasElementsExceptBackground(canvas);
  const isNonEditableProject = dispatch(isNonEditableInspiration());

  let isStickerLocked = false;
  let isCanvasStickerCanvas = false;
  // Check if canvas is wallcanvas not roomcanvas
  if (dispatch(checkIfStickersTypeApp()) && onlyElements.length > 0) {
    isCanvasStickerCanvas = true;
    isStickerLocked = true;
  }

  onlyElements.forEach(element => {
    const canDisable =
      isGrouped ||
      (element.placing && element.placing.locked) ||
      isNonEditableProject ||
      !canDragSticker;
    isStickerLocked = isStickerLocked && canDisable;
    enableOrDisableObject(element, canDisable);
    element.selectable = !isGrouped && !isNonEditableProject;
  });

  if (
    activeObject &&
    activeObject.type == 'activeSelection' &&
    isCanvasStickerCanvas
  ) {
    enableOrDisableObject(activeObject, isStickerLocked);
  }
  canvas.forEachObject(object => {
    if (isBackground(object)) {
      const canDisable =
        (object.placing && object.placing.locked) || isNonEditableProject;
      enableOrDisableObject(object, canDisable);
      object.hasControls = false;
      object.selectable = !isNonEditableProject;
    }
  });
};

export const checkForElementsControls = () => (dispatch, getState) => {
  const { wallCanvas, roomCanvas } = getState().fabricCanvas;
  dispatch(checkForElementsControlsOfCanvas(wallCanvas));
  dispatch(checkForElementsControlsOfCanvas(roomCanvas));
};

export const clearCanvas = () => (dispatch, getState) => {
  const { wallCanvas, roomCanvas } = getState().fabricCanvas;
  if (wallCanvas) {
    wallCanvas.remove(...wallCanvas.getObjects().concat());
  }
  if (roomCanvas) {
    roomCanvas.remove(...roomCanvas.getObjects().concat());
  }
  wallCanvas.discardActiveObject();
};

export const getMaxXPointOfObject = activeObject => {
  let maxPointX = 0;
  if (activeObject.aCoords.bl.x > maxPointX) {
    maxPointX = activeObject.aCoords.bl.x;
  }
  if (activeObject.aCoords.br.x > maxPointX) {
    maxPointX = activeObject.aCoords.br.x;
  }
  if (activeObject.aCoords.tl.x > maxPointX) {
    maxPointX = activeObject.aCoords.tl.x;
  }
  if (activeObject.aCoords.tr.x > maxPointX) {
    maxPointX = activeObject.aCoords.tr.x;
  }
  return maxPointX;
};

export const getMinXPointOfObject = activeObject => {
  let minPointX = 999;
  if (activeObject.aCoords.bl.x < minPointX) {
    minPointX = activeObject.aCoords.bl.x;
  }
  if (activeObject.aCoords.br.x < minPointX) {
    minPointX = activeObject.aCoords.br.x;
  }
  if (activeObject.aCoords.tl.x < minPointX) {
    minPointX = activeObject.aCoords.tl.x;
  }
  if (activeObject.aCoords.tr.x < minPointX) {
    minPointX = activeObject.aCoords.tr.x;
  }
  return minPointX;
};

export const getMaxYPointOfObject = activeObject => {
  let maxPointY = 0;
  if (activeObject.aCoords.bl.y > maxPointY) {
    maxPointY = activeObject.aCoords.bl.y;
  }
  if (activeObject.aCoords.br.y > maxPointY) {
    maxPointY = activeObject.aCoords.br.y;
  }
  if (activeObject.aCoords.tl.y > maxPointY) {
    maxPointY = activeObject.aCoords.tl.y;
  }
  if (activeObject.aCoords.tr.y > maxPointY) {
    maxPointY = activeObject.aCoords.tr.y;
  }
  return maxPointY;
};

export const getMinYPointOfObject = activeObject => {
  let minPointY = 999;
  if (activeObject.aCoords.bl.y < minPointY) {
    minPointY = activeObject.aCoords.bl.y;
  }
  if (activeObject.aCoords.br.y < minPointY) {
    minPointY = activeObject.aCoords.br.y;
  }
  if (activeObject.aCoords.tl.y < minPointY) {
    minPointY = activeObject.aCoords.tl.y;
  }
  if (activeObject.aCoords.tr.y < minPointY) {
    minPointY = activeObject.aCoords.tr.y;
  }
  return minPointY;
};

export const setPositionForElement = (
  element,
  canvas,
  orgX,
  orgY
) => dispatch => {
  const activeObject = canvas.getActiveObject();
  if (activeObject && activeObject.type === 'activeSelection') {
    activeObject.removeWithUpdate(element);
  }
  element.set({
    left: orgX,
    top: orgY
  });
  element.setCoords();

  if (activeObject && activeObject.type === 'activeSelection') {
    activeObject.addWithUpdate(element);
  }
  canvas.renderAll();
  dispatch(toggleDirtyBit());
  dispatch(updatePlacingCoords(element));
};

export const setBoundsForElement = (
  element,
  canvas,
  left,
  top,
  xScale,
  yScale,
  rotationAngle,
  wt,
  ht
) => dispatch => {
  element.set({
    left,
    top
  });
  element.scaleX = xScale;
  element.scaleY = yScale;
  element.width = wt;
  element.height = ht;
  element.angle = rotationAngle;
  element.setCoords();
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const handleHelpCheckBox = status => dispatch => {
  dispatch({
    type: actions.HELP_CHECKBOX,
    payload: {
      value: status
    }
  });
};

//  Pixelation actions
export const setShowPixelationWarningField = condition => (
  dispatch,
  getState
) => {
  dispatch({
    type: actions.SET_SHOW_PIXELATION_WARNING_FIELD,
    payload: {
      showPixelationWarningField: condition
    }
  });

  if (condition) {
    if (!getState().fabricCanvas.setInitialPixelationShown) {
      dispatch(setShowPixelationWindowDialogue(condition));
    }
  } else {
    dispatch(setShowPixelationWindowDialogue(condition));
  }
};

//  Order sample actions
export const showRequestSampleWindow = condition => dispatch => {
  dispatch({
    type: actions.SHOW_REQUEST_SAMPLE_WINDOW,
    payload: {
      showRequestSampleWindow: condition
    }
  });
};

export const showOrderSampleDetailsWindow = condition => (
  dispatch,
  getState
) => {
  dispatch({
    type: actions.SHOW_ORDER_SAMPLE_DETAILS_WINDOW,
    payload: {
      showOrderSampleDetailsWindow: condition
    }
  });
  if (!getState().fabricCanvas.sendPreviewWithLoupe) {
    dispatch(resetActiveProject());
  }
};

export const releaseOrderForSample = orderInfo => dispatch => {
  const emailMessage = orderInfo.message;
  dispatch(
    sendEmailToRecipients(orderInfo.email, emailMessage, orderInfo.name)
  );
};

export const setOrderSampleDetails = details => dispatch => {
  dispatch({
    type: actions.SET_ORDER_SAMPLE_DETAILS,
    payload: {
      orderSampleDetails: details
    }
  });
};

export const setSendPreviewWithLoupe = condition => dispatch => {
  dispatch({
    type: actions.SET_SEND_PREVIEW_WITH_LOUPE,
    payload: {
      sendPreviewWithLoupe: condition
    }
  });
};

export const showOrderedResponseDialog = response => dispatch => {
  if (response) {
    const dict = {
      header: string.THANK_YOU_KEY,
      description: string.EMAIL_NOTIFICATION,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatch(setMessageDialogParams(dict));
  }
  dispatch(showOrderSampleDetailsWindow(false));
};

// share via email
export const setShareLinkType = type => dispatch => {
  dispatch({
    type: actions.SET_SHARE_LINK_TYPE,
    payload: {
      shareLinkType: type
    }
  });
};

export const isEmailValid = emailList => () => {
  if (emailList.length <= 0) {
    return false;
  }
  let valid = true;
  for (let i = 0; i < emailList.length; i++) {
    const emailAddress = emailList[i];
    valid = isValidEmailAddress(emailAddress);
    if (!valid) {
      break;
    }
  }
  return valid;
};

export const isValidName = (name, sendPreviewWithLoupe) => () => {
  let valid = false;
  if (!sendPreviewWithLoupe) {
    valid = true; // share via email
  } else if (name) {
    valid = true;
  } else {
    valid = false;
  }

  return valid;
};

export const isValidUserName = aFullName => {
  let valid = false;
  if (aFullName !== null && aFullName.trim(' ').length !== 0) {
    const fullNameReg = new RegExp('^..*', 'i');
    valid = aFullName.match(fullNameReg) != null;
  }
  return valid;
};

export const isGroupEnabled = canvas => {
  const elements = canvasElementsExceptBackground(canvas);
  let isGrouped = true;
  elements.forEach(ele => {
    if (ele.selectable) {
      isGrouped = false;
    }
  });
  return isGrouped;
};

export const railsifiedString = inStr => {
  const strPath = inStr.split('::');
  const upCase = new RegExp('([ABCDEFGHIJKLMNOPQRSTUVWXYZ])', 'g');
  const fb = new RegExp('^_');
  for (let i = 0; i < strPath.length; i++) {
    strPath[i] = strPath[i].replace(upCase, '_$1').replace(fb, '');
  }
  return strPath.join('/').toLowerCase();
};

export const userIdIsPresent = callback => (dispatch, getState) => {
  let info = null;
  const { id } = getState().modal.storeData;
  const userInfo = getState().fabricCanvas.webUserInfo;
  const { eCommerceServicesUrl } = getState().modal.storeData;
  if (
    getState().modal.envData.platform_flow &&
    getState().modal.envData.platform_user_logged_in
  ) {
    if (!userInfo) {
      api
        .getUserInfo(eCommerceServicesUrl, id)
        .then(res => {
          info = res.data;
          callback(info.id);
          dispatch(setWebUserInfo(info));
        })
        .catch(() => {
          dispatch(setLoadingState(null));
        });
    } else {
      info = userInfo;
      callback(info.id);
    }
  } else {
    callback(info);
  }
};

export const isValidProjectName = aProjectName => {
  if (aProjectName != null) {
    const projectNameReg = new RegExp('^..*', 'i');
    return aProjectName.match(projectNameReg) != null;
  }
  return false;
};

export const isProjectInCart = project => (dispatch, getState) => {
  let hasProjectInCart = false;

  if (getState().finalCheck.project.externalId) {
    const { allExternalProjects } = getState().fabricCanvas;

    for (let i = 0; i < allExternalProjects.length; ++i) {
      if (project.externalId === allExternalProjects[i].id) {
        if (allExternalProjects[i].state === 'IN_CART') {
          hasProjectInCart = true;
        }
        break;
      }
    }
  }
  return hasProjectInCart;
};

export const showVanillaLoginDialogue = condition => dispatch => {
  dispatch({
    type: actions.SET_SHOW_VANILLA_LOGIN_DIALOGUE,
    payload: {
      vanillaLoginIsOpen: condition
    }
  });
};

export const setDialogueFlag = flag => dispatch => {
  dispatch({
    type: actions.SET_DIALOGUE_FLAG,
    payload: {
      dialogueFlag: flag
    }
  });
};

export const minimumViewingDistanceIsUpdated = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  if (wallCanvas) {
    const canvasObjects = wallCanvas.getObjects();
    for (let i = 0; i < canvasObjects.length; i++) {
      const object = canvasObjects[i];
      if (
        Object.prototype.hasOwnProperty.call(object, 'placing') &&
        object.placing.placeableType !== Constants.TEXT_ELEMENT_TYPE
      ) {
        const warning = dispatch(checkForPixelationWarning(object));
        object.hasPixelationWarning = warning;
        dispatch(selectObject(object));
        changeObjectBorderColor(object, dispatch);
        if (warning) {
          break;
        }
      }
    }
  }
};

export const changeObjectBorderColor = (object, dispatch) => {
  if (
    Object.prototype.hasOwnProperty.call(object, 'hasPixelationWarning') &&
    object.hasPixelationWarning
  ) {
    fabric.Object.prototype.set({
      borderColor: 'rgb(253, 136, 54)',
      cornerColor: 'rgb(253, 136, 54)'
    });
    dispatch(setShowPixelationWarningField(true));
  } else {
    fabric.Object.prototype.set({
      cornerColor: 'rgb(128,128,128)',
      borderColor: 'rgb(128,128,128)'
    });
    dispatch(setShowPixelationWarningField(false));
  }
};

export const setControlEdges = element => () => {
  if (isFurnitureLayout(element)) {
    element.setControlsVisibility({
      tl: true, // top-left
      mt: false, //  middle-top
      tr: true, // top-right
      ml: false, // middle-left
      mr: false, // middle-right
      bl: false, //  bottom-left
      mb: false, // middle-bottom
      br: false, // bottom-right
      mtr: false // bottom-right
    });
    element.hasRotatingPoint = false;
  } else if (Object.prototype.hasOwnProperty.call(element, 'resizeType')) {
    if (element.resizeType === 'arbitrarily') {
      element.setControlsVisibility({
        tl: true, // top-left
        mt: true, //  middle-top
        tr: true, // top-right
        ml: true, // middle-left
        mr: true, // middle-right
        bl: true, //  bottom-left
        mb: true, // middle-bottom
        br: true, // bottom-right
        mtr: false // bottom-right
      });
    } else {
      element.setControlsVisibility({
        tl: true, // top-left
        mt: false, //  middle-top
        tr: true, // top-right
        ml: false, // middle-left
        mr: false, // middle-right
        bl: true, //  bottom-left
        mb: false, // middle-bottom
        br: true, // bottom-right
        mtr: true // bottom-right
      });
    }
  }
};

export const setMessageDialogParams = dict => dispatch => {
  dispatch({
    type: actions.SET_DIALOGUE_PARAMS,
    payload: {
      info: dict
    }
  });
  dispatch(setDialogueFlag(true));
};

export const setWebLinkSaveIdentifier = identifier => dispatch => {
  dispatch({
    type: actions.SET_WEB_LINK_SAVE_IDENTIFIER,
    payload: {
      webLinkSaveIdentifier: identifier
    }
  });
};

export const projectFolderValidation = folder => (dispatch, getState) => {
  const folderType = getState().fabricCanvas.webLinkSaveFolderType;
  const { rootFolders } = getState().fabricCanvas;
  if (folderType === Constants.EXISTING_FOLDER_TYPE) {
    return true;
  }
  if (folderType === Constants.NEW_FOLDER_TYPE) {
    for (let i = 0; i < rootFolders.length; i++) {
      if (folder === rootFolders[i]) {
        return false;
      }
    }
    return true;
  }
  return false;
};

export const projectNameValidation = projectName => (dispatch, getState) => {
  const { allExternalProjects } = getState().fabricCanvas;
  const { externalId } = getState().finalCheck.project;

  for (let i = 0; i < allExternalProjects.length; i++) {
    if (
      projectName === allExternalProjects[i].name &&
      externalId !== allExternalProjects[i].id
    ) {
      return false;
    }
  }
  return true;
};

export const setShareMedium = medium => dispatch => {
  dispatch({
    type: actions.SET_SHARE_MEDIUM,
    payload: {
      shareMedium: medium
    }
  });
};

export const setIframe = condition => dispatch => {
  dispatch({
    type: actions.SET_IFRAME,
    payload: {
      showIframe: condition
    }
  });
  if (!condition) {
    dispatch(resetActiveProject());
  }
};

export const setDefaultMaskStepForOrderSample = step => dispatch => {
  dispatch({
    type: actions.SET_DEFAULT_MASK_STEP_FOR_ORDER_SAMPLE,
    payload: {
      defaultMaskStepForOrderSample: step
    }
  });
};

export const setActiveObjectGroup = e => (dispatch, getState) => {
  const targetObject = e.target;
  const { selectedObjects, activeSelection } = getState().fabricCanvas;
  const updatedObjects = [...selectedObjects];
  const canvas = dispatch(getActiveCanvas(targetObject.placing));
  if (!canvas) {
    return;
  }

  // Before making it group need to check if previously it had selected scene.If so remove it.
  if (
    updatedObjects.length === 1 &&
    Object.prototype.hasOwnProperty.call(updatedObjects[0], 'placing') &&
    isBackgroundTypeElement(updatedObjects[0].placing)
  ) {
    updatedObjects.splice(0, updatedObjects.length);
  }

  // Group it only if it is not locked also not a background.
  if (
    updatedObjects &&
    !targetObject.lockMovementX &&
    Object.prototype.hasOwnProperty.call(targetObject, 'placing') &&
    !isBackgroundTypeElement(targetObject.placing)
  ) {
    updatedObjects.push(targetObject);
  }
  dispatch({
    type: actions.SET_SELECTED_OBJECTS,
    payload: {
      selectedObjects: updatedObjects
    }
  });
  canvas.discardActiveObject();
  if (updatedObjects.length < 1) return;

  if (updatedObjects.length == 1) {
    canvas.setActiveObject(updatedObjects[0]);
  } else if (activeSelection && activeSelection.type === 'activeSelection') {
    activeSelection.addWithUpdate(targetObject);
    canvas.setActiveObject(activeSelection);
  } else {
    const selection = new fabric.ActiveSelection(updatedObjects, {
      canvas
    });
    selection.type = 'activeSelection';
    canvas.setActiveObject(selection);
  }

  dispatch(toolBarRerender());
  canvas.requestRenderAll();
};

export const setActiveObjectSingle = e => (dispatch, getState) => {
  const { selectedObjects } = getState().fabricCanvas;
  const canvas = dispatch(getActiveCanvas(e.target.placing));
  if (!canvas) {
    return;
  }
  const targetObject = e.target; // activeObject
  if (canvas.getActiveObject().type == 'activeSelection') {
    dispatch({
      type: actions.SET_ACTIVE_SELECTION,
      payload: {
        activeSelection: canvas.getActiveObject()
      }
    });
  }
  const updatedObjects = [...selectedObjects];

  if (updatedObjects.length != 0) {
    updatedObjects.splice(0, updatedObjects.length);
  }
  updatedObjects.push(targetObject);

  dispatch({
    type: actions.SET_SELECTED_OBJECTS,
    payload: {
      selectedObjects: updatedObjects
    }
  });
  dispatch(toolBarRerender());
};

export const clearActiveObjects = () => dispatch => {
  dispatch({
    type: actions.SET_SELECTED_OBJECTS,
    payload: {
      selectedObjects: []
    }
  });
};

export const toolBarRerender = () => dispatch => {
  dispatch({
    type: actions.RERENDER_FLAG
  });
};

export const redrawCanvas = () => dispatch => {
  dispatch({
    type: actions.REDRAW_CANVAS
  });
};

export const setFeedbackDialogue = e => (dispatch, getState) => {
  const isViewOnlyPreviewMode = getState().modal.envData.view_only_preview_mode;
  if (!isViewOnlyPreviewMode) {
    dispatch({
      type: actions.SET_FEEDBACK_DIALOGUE,
      payload: {
        showFeedbackDialogue: e
      }
    });
  }
};

export const setFeedbackState = e => dispatch => {
  dispatch({
    type: actions.SET_FEEDBACK_STATE,
    payload: {
      feedbackState: e
    }
  });
};

export const sendFeedbackDetails = (data, callback) => () => {
  api
    .sendFeedbackDetails(data)
    .then(() => {
      callback();
    })
    .catch(() => {
      callback();
    });
};

export const setProjectSubmissionState = e => dispatch => {
  dispatch({
    type: actions.SET_PROJECT_SUBMISSION_STATE,
    payload: {
      projectSubmissionState: e
    }
  });
};

export const setViewMode = viewType => (dispatch, getState) => {
  let editedViewTYpe = viewType;
  if (viewType == Constants.VISUALIZE_TYPE) {
    dispatch(generatePreviewOfStickers());
    editedViewTYpe = Constants.TWO_D_TYPE;
  }
  if (getState().fabricCanvas.viewType !== editedViewTYpe) {
    dispatch(setViewType(editedViewTYpe));
  }
};

export const setViewType = viewType => dispatch => {
  dispatch(selectObject(null));
  dispatch({
    type: actions.SET_VIEW_TYPE,
    payload: { value: viewType }
  });
  if (dispatch(checkIfCanvasApp())) {
    dispatch(updateCanvasForChangeInSize());
  }
};

export const setIsThreeDViewLoaded = isLoaded => dispatch => {
  dispatch({
    type: actions.SET_IS_3D_VIEW_LOADED,
    payload: { is3DViewLoaded: isLoaded }
  });
};

export const setInitialLoader = isLoaded => dispatch => {
  dispatch({
    type: actions.SET_INITIAL_LOADER,
    payload: { initialLoader: isLoaded }
  });
};

export const refresh3D = () => dispatch => {
  dispatch({
    type: actions.REFRESH_3D
  });
};

export const fetchProductId = () => (dispatch, getState) => {
  let productId;
  const { supportedProducts } = getState().modal.storeData;

  supportedProducts.forEach(product => {
    if (product.category === getState().modal.envData.category) {
      productId = product.productId;
    }
  });
  return productId;
};

export const setFeedbackRating = rating => dispatch => {
  dispatch({
    type: actions.SET_FEEDBACK_RATING,
    payload: { feedbackRating: rating.key }
  });
};

export const setFeedbackPermission = value => dispatch => {
  dispatch({
    type: actions.SET_FEEDBACK_PERMISSION_STATE,
    payload: {
      feedbackPermission: value
    }
  });
};

export const setFeedbackReview = review => dispatch => {
  dispatch({
    type: actions.SET_FEEDBACK_REVIEW,
    payload: { feedbackReview: review }
  });
};

export const checkForBlockChainTransaction = () => dispatch => {
  const isBlockChainEnabled = dispatch(isBlockchainTransactionEnabled());
  const isLaptop = isLaptopsApp(dispatch(getCategoryOfProduct()));
  return isBlockChainEnabled && isLaptop;
};

export const sendReviewOrderGA = shouldSend => dispatch => {
  dispatch({
    type: actions.SEND_REVIEW_ORDER_GA,
    payload: { sendReviewGA: shouldSend }
  });
};

export const handleRequestSample = () => dispatch => {
  dispatch(showRequestSampleWindow(true));
  dispatch(setDefaultMaskStepForOrderSample(Constants.INITIAL_LOAD));
  dispatch(selectObject(null));
};

export const setBlockchainTransactionInProgress = flag => dispatch => {
  dispatch({
    type: actions.BLOCKCHAIN_TRANSACTION_IN_PROGRESS,
    payload: { blockChainTransactionInProgress: flag }
  });
};

export const isVisualizeModeActive = () => (dispatch, getState) => {
  const { viewType } = getState().fabricCanvas;
  return (
    dispatch(checkIfStickersTypeApp()) &&
    (viewType == Constants.THREE_D_TYPE || viewType == Constants.TWO_D_TYPE)
  );
};

export const setDraggableCanvasPosition = (x, y) => dispatch => {
  dispatch({
    type: actions.SET_DRAGGABLE_CANVAS_POSITION,
    payload: { x, y }
  });
};

export const initializeProjectPlacing = () => (dispatch, getState) => {
  const draggableCanvas = document.getElementById('rnd');
  if (draggableCanvas) {
    const { project } = getState().finalCheck;
    const placing = new Placing(project);
    placing.placeableType = Constants.PROJECT_KEY;
    draggableCanvas.placing = placing;
  }
};
